export const headCellsTextfield = [
    {
        id: 'eSIMSelezionate',
        label: 'eSIM selezionate',
        width: "30%"
    },
    {
        id: 'esitoInvioPrecedente',
        label: 'Esito invio precedente',
        width: "20%"
    },
    {
        id: 'emailAssociata',
        label: 'Email associata',
        width: "50%"
    }
]

export const riepilogoHeadCells = [
    {
        id: 'eSIMSelezionate',
        label: 'eSIM selezionate',
        width: "30%"
    },
    {
        id: 'emailAssociata',
        label: 'Email associata',
        width: "70%"
    }
]